import { csx } from '@vtex/admin-ui'

export const styles = {
  footer: csx({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '$space-7',
    '&&': { borderTop: '$neutral' },
  }),

  footerButtons: csx({
    display: 'flex',
  }),

  holdAndSaveButton: csx({
    '[data-loading="false"]': {
      position: 'relative',
      overflow: 'hidden',
      background: '$action.main.secondary',
      zIndex: 0,
      whiteSpace: 'nowrap',

      '::before': {
        content: '',
        position: 'absolute',
        inset: 0,
        width: '0%',
        zIndex: -1,
        background: '$action.main.primary',
        transition: 'width 3s linear',
      },

      '::after': {
        content: 'attr(aria-label)',
        position: 'absolute',
        inset: 0,
        color: '$white',
        width: '0%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        transition: 'width 3s linear',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '$space-3',
      },

      '[data-held="true"]::before': { width: '100%' },
      '[data-held="false"]::before': { width: '0%' },

      '[data-held="true"]::after': { width: '100%' },
      '[data-held="false"]::after': { width: '0%' },
    },
  }),
}
